import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import { languageData } from "./data/languageData.js";

const resources = {
  tr: languageData.language.tr,
  en: languageData.language.en,
};

// The language comes from the URL: /en/... is English, everything else Turkish. The prerender
// and the browser derive it the same way, so the first client render always matches the
// prerendered HTML. Don't read it from localStorage or the browser (hydration mismatch).
export const pageLanguage = () =>
  typeof window !== "undefined" && window.location.pathname.startsWith("/en") ? "en" : "tr";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: resources,
    lng: pageLanguage(),
    fallbackLng: "tr",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
